import React from 'react';

interface QuickStats {
  criticalTasks: number;
  urgentCutoffs: number;
  arrivingSoon: number;
  shipmentsEnRoute: number;
}

interface DashboardHeaderProps {
  userName: string;
  stats: QuickStats;
  onStatClick?: (statType: keyof QuickStats) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ 
  userName, 
  stats,
  onStatClick 
}) => {
  return (
    <div className="dashboard-header">
      <div className="dashboard-header-content">
        <h1>Dashboard</h1>
        <p>Welcome back, {userName}. Here's what needs your attention.</p>
      </div>
      
      <div className="quick-stats">
        <div 
          className="stat-card critical"
          onClick={() => onStatClick?.('criticalTasks')}
          role="button"
          tabIndex={0}
          aria-label={`${stats.criticalTasks} critical tasks`}
        >
          <div className="stat-value">{stats.criticalTasks}</div>
          <div className="stat-label">Critical Tasks</div>
        </div>
        
        <div 
          className="stat-card urgent"
          onClick={() => onStatClick?.('urgentCutoffs')}
          role="button"
          tabIndex={0}
          aria-label={`${stats.urgentCutoffs} urgent cutoffs`}
        >
          <div className="stat-value">{stats.urgentCutoffs}</div>
          <div className="stat-label">Urgent Cutoffs</div>
        </div>
        
        <div 
          className="stat-card arriving"
          onClick={() => onStatClick?.('arrivingSoon')}
          role="button"
          tabIndex={0}
          aria-label={`${stats.arrivingSoon} arriving soon`}
        >
          <div className="stat-value">{stats.arrivingSoon}</div>
          <div className="stat-label">Arriving Soon</div>
        </div>
        
        <div 
          className="stat-card vessels"
          onClick={() => onStatClick?.('shipmentsEnRoute')}
          role="button"
          tabIndex={0}
          aria-label={`${stats.shipmentsEnRoute} shipments en route`}
        >
          <div className="stat-value">{stats.shipmentsEnRoute}</div>
          <div className="stat-label">Shipments en Route</div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
